import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOrders,
  cancelOrder,
  fetchMediaData,
  setCurrentPage,
  pagesCount,
} from "../../features/orders/ordersSlice";
import { Link } from "react-router-dom";
import Invoice from "../Invoice";

const MyOrders = () => {
  const dispatch = useDispatch();
  const { totalPages, currentPage, tabChange } = useSelector(
    (state) => state.orders
  );

  const { orders, status, mediaData, error } = useSelector(
    (state) => state.orders
  );
  const [page, setPage] = useState(1);
  // const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    if (tabChange === "my-orders") {
      dispatch(fetchOrders(page)).then((result) => {
        dispatch(fetchMediaData(result.payload));
      });
    } else {
      setPage(1);
      dispatch(setCurrentPage(1));
      dispatch(pagesCount(0));
    }
  }, [dispatch, page, tabChange]);

  if (status === "loading") {
    return <div>Loading...</div>;
  }

  if (status === "failed") {
    return <div>Error: {error}</div>;
  }

  const handleCancelOrder = (orderId) => {
    dispatch(cancelOrder(orderId));
  };

  // const handleOrderClick = () => {
  //   navigate(`/ordertracking`); // Navigate to order tracking page
  // };

  const renderOrderItem = (order) => {
    // Determine the text color based on order status
    const statusColor =
      order.status.toLowerCase() === "cancelled" ? "red" : "green";

    return (
      <div key={order._id} className="items-in-cart Delivered-box">
        <div className="div-txt-with-item-fr">
          <h3 className="heading-img-item-fr" style={{ color: statusColor }}>
            Order Status: {order.status}
          </h3>
          <h5 className="head-add-item-fr">
            Order ID: {order._id} <Invoice orderId={order._id} />
            {(order.status === "pending" || order.status === "dispatch") && (
              <button
                type="button"
                aria-label="Close"
                onClick={() => handleCancelOrder(order._id)} // Pass order ID
                className="danger-red ms-3"
              >
                Cancel
              </button>
            )}
          </h5>
        </div>
        {order.products && order.products.length > 0 ? (
          order.products.map((product) => (
            <div key={product.media_id} className="cart-item">
              {mediaData[product.media_id] ? (
                <img
                  src={mediaData[product.media_id].url}
                  alt={product.product.title}
                />
              ) : (
                <p>Loading image...</p>
              )}
              <div className="item-details">
                <div className="item-header">
                  <h3>{product.product.title}</h3>
                  {/* <p>Size: {product.product_variant.size}</p>
                  <p>Price: ${product.product_variant.price}</p> */}
                </div>
                <p>Return or replace items: Eligible up to August 30, 2024</p>
                <div className="price-quantity">
                  <Link className="bitag" to={`/cartpage`}>
                    Buy it again
                  </Link>{" "}
                  <Link
                    className="viyitem"
                    to={`/productdetails/${product.product._id}`}
                  >
                    View your item
                  </Link>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No products found in this order.</p>
        )}
      </div>
    );
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
      dispatch(setCurrentPage(newPage));
    }
  };

  return (
    <div className="container">
      <div className="main-div my-orders">
        <div className="row">
          <div className="col-lg-12">
            <h1>My Orders</h1>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={60}
              height={4}
              viewBox="0 0 60 4"
              fill="none"
            >
              <line y1={2} x2={60} y2={2} stroke="#EE3137" strokeWidth={4} />
            </svg>
          </div>
        </div>

        {/* Tabs */}
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="all-orders-tab"
              data-bs-toggle="tab"
              data-bs-target="#all-orders"
              type="button"
              role="tab"
              aria-controls="all-orders"
              aria-selected="true"
            >
              All Orders
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="delivered-tab"
              data-bs-toggle="tab"
              data-bs-target="#delivered"
              type="button"
              role="tab"
              aria-controls="delivered"
              aria-selected="false"
            >
              Delivered
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="canceled-tab"
              data-bs-toggle="tab"
              data-bs-target="#canceled"
              type="button"
              role="tab"
              aria-controls="canceled"
              aria-selected="false"
            >
              Canceled
            </button>
          </li>
        </ul>

        {/* Tab Content */}
        <div className="tab-content my-oders-2" id="myTabContent">
          {/* All Orders Tab */}
          <div
            className="tab-pane fade show active"
            id="all-orders"
            role="tabpanel"
            aria-labelledby="all-orders-tab"
          >
            <div className="container mt-3">
              <div className="main-div my-oders-2">
                <div className="row">
                  <div className="line-sub">
                   
                    {orders && orders.length > 0 ? (
                      orders.map((order) => renderOrderItem(order))
                    ) : (
                      <div className="empty-box">
                        <div className="items-in-cart text-center border-0">
                          <h6 className="mb-3">No Orders Found!</h6>
                          <Link href="#" className="order-button">
                            Order Now
                          </Link>
                        </div>
                      </div>
                    )}
                    <div className="col-auto">
                      <nav aria-label="Page navigation">
                        <ul className="pagination justify-content-end mb-0">
                          {/* Previous Button */}
                          <li
                            className={`page-item ${
                              currentPage <= 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage <= 1}
                            >
                              Previous
                            </button>
                          </li>

                          {/* Show limited page numbers */}
                          {Array.from({ length: totalPages }, (_, i) => i + 1)
                            .filter(
                              (page) =>
                                page === 1 ||
                                page === totalPages ||
                                (page >= currentPage - 2 &&
                                  page <= currentPage + 2)
                            )
                            .map((page, index, arr) => (
                              <React.Fragment key={page}>
                                {index > 0 && arr[index - 1] !== page - 1 && (
                                  <li className="page-item disabled">
                                    <span className="page-link">...</span>
                                  </li>
                                )}
                                <li
                                  className={`page-item ${
                                    currentPage === page ? "active" : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => handlePageChange(page)}
                                  >
                                    {page}
                                  </button>
                                </li>
                              </React.Fragment>
                            ))}

                          {/* Next Button */}
                          <li
                            className={`page-item ${
                              currentPage >= totalPages ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage >= totalPages}
                            >
                              Next
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Delivered Orders Tab */}
          <div
            className="tab-pane fade"
            id="delivered"
            role="tabpanel"
            aria-labelledby="delivered-tab"
          >
            <div className="container mt-3">
              <div className="main-div my-oders-2">
                <div className="row">
                  <div className="line-sub">
               
                    {orders && orders.length > 0 ? (
                      orders
                        .filter((order) => order.status === "delivered")
                        .map((order) => (
                          <div key={order._id} className="order-item">
                            {renderOrderItem(order)}
                          </div>
                        ))
                    ) : (
                      <div className="empty-box">
                        <div className="items-in-cart text-center border-0">
                          <h6 className="mb-3">No Delivered Orders Found!</h6>
                          <Link href="#" className="order-button">
                            Order Now
                          </Link>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Canceled Orders Tab */}
          <div
            className="tab-pane fade"
            id="canceled"
            role="tabpanel"
            aria-labelledby="canceled-tab"
          >
            <div className="container mt-3">
              <div className="main-div my-oders-2">
                <div className="row">
                  <div className="line-sub">
                    {orders && orders.length > 0 ? (
                      orders
                        .filter((order) => order.status === "cancelled")
                        .map((order) => renderOrderItem(order))
                    ) : (
                      <div className="empty-box">
                        <div className="items-in-cart text-center border-0">
                          <h6 className="mb-3">No Canceled Orders Found!</h6>
                          <Link href="#" className="order-button">
                            Order Now
                          </Link>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyOrders;
